var React = require('react');

function HowItWorksPipe (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#D4E8E8","fillRule":"nonzero","d":"M.85 13.392C19.932 4.817 40.666.53 63.051.53c22.385 0 41.552 3.642 57.502 10.926L100 89.94V968H27V89.939L.85 13.392z","opacity":".414"}));
}

HowItWorksPipe.defaultProps = {"width":"121"};

module.exports = HowItWorksPipe;

HowItWorksPipe.default = HowItWorksPipe;
